// extracted by mini-css-extract-plugin
export var container = "_9g-0";
export var error = "_9g-9";
export var label = "_9g-5";
export var light = "_9g-6";
export var md = "_9g-3";
export var sm = "_9g-2";
export var thin = "_9g-8";
export var thinBold = "_9g-7";
export var vertical = "_9g-4";
export var xs = "_9g-1";